import { render, staticRenderFns } from "./TemplatesDetails.vue?vue&type=template&id=ef32b09e&scoped=true&"
import script from "./TemplatesDetails.vue?vue&type=script&lang=js&"
export * from "./TemplatesDetails.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesDetails.vue?vue&type=style&index=0&id=ef32b09e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef32b09e",
  null
  
)

export default component.exports